import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import './Card.css';
import {
  CardBody,
  CardContainer,
  CardInput,
  CardText,
  FormButton,
  FormRow,
  GhostButton,
  Toggler,
} from './CardComponents';
import Swal from 'sweetalert2';
import Loader from 'react-loader-spinner';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  filterByState,
  updateStationById,
} from '../../store/features/stationSlice';
import { HttpListClient } from '../../utils/HttpClient';
import { setIsLoadingTo } from '../../store/features/adminSlice';
import routes from '../../router/routes';

const styles = {
  option: (provided, state) => ({
    ...provided,
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: 'inherit',
    color: state.isSelected ? '#323637' : '#323637',
    backgroundColor: state.isSelected ? '#E6E8E8' : '#F2F3F3',
  }),
  container: (provided, state) => ({
    ...provided,
    height: '42px',
    marginTop: '20px',
    width: '270px',
  }),
  menu: (provided, state) => ({
    ...provided,
    margin: 0,
    border: 0,
    outline: 0,
    backgroundColor: '#F2F3F3',
    borderRadius: '0 0 5px 5px',
    fontSize: '18px',
    fontFamily: 'inherit',
    color: '#323637',
    zIndex: '20',
  }),
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#E9ECEF',
    border: 0,
    outline: 0,
    fontSize: '14px',
    fontFamily: 'inherit',
    color: '#323637',
    height: '100%',
    borderRadius: '10px',
    width: '274px',
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    fontFamily: 'inherit',
    color: '#323637',
    backgroundColor: '#E9ECEF',
    cursor: 'pointer',
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    cursor: 'pointer',
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: '#323637',
    fontFamily: 'Montserrat',
    fontSize: '14px',
  }),
};

const Card = ({ station, provinces }) => {
  const history = useHistory();
  const nameRef = useRef(null);
  const sourceRef = useRef(null);
  const dispatch = useDispatch();

  const { provinceIdMap, provinceArray } = useSelector(
    (state) => state.stations,
  );
  const { user } = useSelector((state) => state.admin);

  const [isLoading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [currentName, setCurrentName] = useState(station.Name);
  const [currentSource, setCurrentSource] = useState(station.Source);
  const [currentActive, setCurrentActive] = useState(station.IsActive);
  const [currentProvince, setCurrentProvince] = useState({
    label: provinceIdMap[station.PlaceId]?.Name ?? ' ',
    value: provinceIdMap[station.PlaceId]?.Id ?? ' ',
  });
  const { searchByState } = useSelector((state) => state.stations);

  const SAVE_STATION_URL = '/saveStation';

  const handleSubmit = async () => {
    let hasError = false;
    let validNameLength = nameRef.current.value.length > 4;
    let validSourceURI = sourceRef.current.value.length > 4;
    let name = currentName;
    let edittedStation = {
      ...station,
      Id: station.Id,
      Name: name,
      PlaceId: currentProvince.value,
      IsActive: currentActive,
      Source: currentSource,
      ModifyBy:  parseInt(user.id) || parseInt(user.Id)
    };
    delete edittedStation["EntryBy"]
    try {
      setLoading(true);
      if (validNameLength && validSourceURI) {
        let res = await HttpListClient.post(SAVE_STATION_URL, edittedStation);
        console.log(res)
      } else {
        throw new Error('Error con usuario');
      }
    } catch (error) {
      hasError = true;
      Swal.fire({
        title: 'Error',
        icon: 'error',
        timer: 2000,
        text: 'Ha ocurrido un error por favor intentar mas tarde.',
        confirmButtonColor: '#003876',
      });
    } finally {
      setLoading(false);
      if (hasError) {
        Swal.fire({
          title: 'Error',
          text: 'Se ha producido un error al intentar editar la emisora',
          icon: 'error',
          confirmButtonColor: '#003876',
        });
      } else {
        Swal.fire({
          title: 'Exito',
          text: 'Se ha editado la emisora exitosamente',
          icon: 'success',
          confirmButtonText: 'Ok',
          confirmButtonColor: '#003876',
        });
        dispatch(filterByState(searchByState));
        dispatch(setIsLoadingTo(true));
        dispatch(setIsLoadingTo(false));
        dispatch(updateStationById(edittedStation));
        history.push(routes.admin);
      }
    }
  };

  const handleCancel = () => history.push('/gestion-administrador');

  const isClassActive = (state) => (state ? 'active' : '');

  const PresentSpinner = () => (
    <div
      style={{
        height: '80vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Loader type="TailSpin" color="#00BFFF" height={100} width={100} />
    </div>
  );

  useEffect(() => {
    let map = [];

    provinceArray.forEach((province) => {
      let newProvince = { value: province.Id, label: province.Name };
      map.push(newProvince);
    });
    setOptions(map);
  }, []);

  return (
    <>
      {isLoading ? (
        <PresentSpinner />
      ) : (
        <CardContainer style={{ backgroundColor: '#F6F7F9' }}>
          <CardBody style={{ margin: 'auto' }}>
            <label style={{ marginBottom: '-10px', marginTop: '20px' }}>
              Nombre de emisora
            </label>
            <CardInput
              maxLength="25"
              ref={nameRef}
              onChange={(e) => setCurrentName(e.target.value)}
              value={currentName ?? ''}
            />
            <label style={{ marginBottom: '-10px', marginTop: '20px' }}>
              Provincia
            </label>
            <Select
              options={options}
              styles={styles}
              label="Filtrar"
              defaultValue={{ value: 1, label: 'Provincias' }}
              onChange={(e) => setCurrentProvince(e)}
            />
            <label style={{ marginBottom: '-10px', marginTop: '20px' }}>
              URL de transmision
            </label>
            <CardInput
              ref={sourceRef}
              onChange={(e) => setCurrentSource(e.target.value)}
              value={currentSource ?? ''}
            />
            <FormRow>
              <CardText
                style={{
                  fontSize: '1.3rem',
                  margin: '0',
                  marginRight: 'auto',
                  fontWeight: '500',
                }}>
                Estatus
              </CardText>
              <Toggler
                onClick={() => setCurrentActive(!currentActive)}
                className={isClassActive(currentActive)}
                isActive={true}
              />
            </FormRow>
            <FormRow style={{ marginTop: '20px' }}>
              <GhostButton onClick={handleCancel}>Cancelar</GhostButton>
              <FormButton onClick={handleSubmit}>Guardar</FormButton>
            </FormRow>
          </CardBody>
        </CardContainer>
      )}
    </>
  );
};

export default Card;
